// extracted by mini-css-extract-plugin
module.exports = {"container":"Calendar_container__kh-9G","arrowButton":"Calendar_arrowButton__22gbl","arrow":"Calendar_arrow__1zpRR","title":"Calendar_title__BG5pV"};